module.exports = InternalShared('InternalShared/PageBuilder/Services/DragDropService');